<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="25rem"
  >
    <template v-slot:activator="{ on }">
      <v-btn icon text v-on="on">
        <v-icon>mdi-playlist-edit</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="pa-1">
        <v-row dense no-gutters align="start" justify="end">
          <v-btn small icon text @click="dialog = !dialog">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid" @submit.prevent="update">
          <j-decimal-input
            ref="input"
            dense
            filled
            :min="0"
            step="1"
            class="no-before"
            v-model="index"
            label="Nouvelle position"
            required
          >
          </j-decimal-input>
        </v-form>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-row align="center" justify="end" dense no-gutters>
          <v-btn
            :disabled="valid === false"
            small
            color="success"
            @click="update"
          >
            Modifier
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "InventoryTemplateEditorPositionDialog",
  data() {
    return {
      index: null,
      dialog: false,
      valid: false
    };
  },
  methods: {
    update() {
      if (this.valid === true) {
        this.$emit("update", this.index);
        this.dialog = false;
      }
    }
  },
  watch: {
    dialog(v) {
      if (v === false) {
        setTimeout(() => (this.index = null), 100);
      } else {
        setTimeout(() => this.$refs.input.focus(), 100);
      }
    }
  }
};
</script>

<style></style>
